/**
 * Storage Utility
 * Handles local storage operations for user data
 */

const STORAGE_KEYS = {
    USER: 'hipoteca_user',
    TOKEN: 'hipoteca_token',
    PROFILE: 'hipoteca_profile',
    EXPENSES: 'hipoteca_expenses',
    GUIDE_PROGRESS: 'hipoteca_guide_progress',
    HOME_GOAL: 'hipoteca_home_goal',
    SUBSCRIPTION: 'hipoteca_subscription'
};

export const storage = {
    // User
    getUser() {
        const data = localStorage.getItem(STORAGE_KEYS.USER);
        return data ? JSON.parse(data) : null;
    },

    setUser(user) {
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    },

    clearUser() {
        localStorage.removeItem(STORAGE_KEYS.USER);
    },

    // JWT Token
    getToken() {
        return localStorage.getItem(STORAGE_KEYS.TOKEN);
    },

    setToken(token) {
        localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    },

    clearToken() {
        localStorage.removeItem(STORAGE_KEYS.TOKEN);
    },

    // Profile
    getProfile() {
        const data = localStorage.getItem(STORAGE_KEYS.PROFILE);
        return data ? JSON.parse(data) : null;
    },

    setProfile(profile) {
        if (profile === null) {
            localStorage.removeItem(STORAGE_KEYS.PROFILE);
        } else {
            localStorage.setItem(STORAGE_KEYS.PROFILE, JSON.stringify(profile));
        }
    },

    // Expenses
    getExpenses() {
        const data = localStorage.getItem(STORAGE_KEYS.EXPENSES);
        return data ? JSON.parse(data) : null;
    },

    setExpenses(expenses) {
        localStorage.setItem(STORAGE_KEYS.EXPENSES, JSON.stringify(expenses));
    },

    // Guide Progress
    getGuideProgress() {
        const data = localStorage.getItem(STORAGE_KEYS.GUIDE_PROGRESS);
        return data ? JSON.parse(data) : { step: 1, completed: false };
    },

    setGuideProgress(progress) {
        localStorage.setItem(STORAGE_KEYS.GUIDE_PROGRESS, JSON.stringify(progress));
    },



    // Home Goal (Target Price & Mortgage %)
    getHomeGoal() {
        const data = localStorage.getItem(STORAGE_KEYS.HOME_GOAL);
        return data ? JSON.parse(data) : { price: 200000, mortgagePercentage: 80 };
    },

    setHomeGoal(goal) {
        localStorage.setItem(STORAGE_KEYS.HOME_GOAL, JSON.stringify(goal));
    },

    // Subscription
    getSubscription() {
        const data = localStorage.getItem(STORAGE_KEYS.SUBSCRIPTION);
        return data ? JSON.parse(data) : { status: 'none', plan: null };
    },

    setSubscription(subscription) {
        localStorage.setItem(STORAGE_KEYS.SUBSCRIPTION, JSON.stringify(subscription));
    },

    getTrialDaysLeft() {
        const subscription = this.getSubscription();
        if (subscription.status !== 'trialing' || !subscription.trialEnd) return 0;
        const now = new Date();
        const trialEnd = new Date(subscription.trialEnd);
        const diffMs = trialEnd - now;
        return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
    },

    // Clear all data
    clearAll() {
        Object.values(STORAGE_KEYS).forEach(key => {
            localStorage.removeItem(key);
        });
    }
};

// Auth check
export function isAuthenticated() {
    return storage.getUser() !== null;
}

export function hasProfile() {
    return storage.getProfile() !== null;
}

export function requireAuth() {
    if (!isAuthenticated()) {
        window.router.navigate('/auth');
        return false;
    }
    return true;
}

export function requireProfile() {
    if (!hasProfile()) {
        window.router.navigate('/onboarding');
        return false;
    }
    return true;
}

